import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core"
import "../assets/css/main.css";
import ProduktDevDesktop from "./page/wizard/step-antrag/produkt/ProduktDevDesktop";
import AgenturAvatar from "./agentur/avatar/AgenturAvatar";
import Images from "../assets/images";

const useStyles = makeStyles((theme: Theme) => createStyles({
    header: {
        backgroundColor: '#cce4f0',
    },
    headerLogo: {
        width: 160,
        backgroundColor: '#FFF',
        borderBottomLeftRadius: 14,
        borderBottomRightRadius: 14,
        padding: 20,
        paddingBottom: 15
    },
    headerDogoramaLogo: {
        width: '100%',
        height: '100%'        
    },
    headerDogoramaLogoImage: {
        height: '63px',
        maxWidth: '100%',
        textAlign: 'left',
        marginLeft: '-27px',
        paddingTop: '18px'
    },
    headerLogoImage: {
        height: 'auto',
        maxWidth: '100%'
    }
}));


const AppHeaderDesktop: React.FC<{ showProduktInfos: boolean, isDogorama: boolean }> = ({ showProduktInfos, isDogorama }) => {
    const classes = useStyles();
    const columnCountRheinLandLogo = isDogorama ? 3 : 7;

    return (
        <Grid container className={classes.header}>
            <Grid item md={columnCountRheinLandLogo}>
                <div className={classes.headerLogo}>
                    <img src={Images.logo} className={classes.headerLogoImage} alt="RheinLand Versicherungsgruppe Logo"></img>
                </div>
            </Grid>
            {isDogorama && 
                <Grid item md={4}>
                    <div className={classes.headerDogoramaLogo}>
                        <img src={Images.dogoramaLogo} className={classes.headerDogoramaLogoImage} alt="DOGORAMA Logo"></img>
                    </div>
                </Grid>
            }
            <Grid item md={5} container justifyContent='flex-end'>
                <AgenturAvatar />
                {showProduktInfos &&
                    <div style={{ top: 160, position: 'absolute', width: 225 }}>
                        <ProduktDevDesktop />
                    </div>
                }
            </Grid>
        </Grid>
    );
}

export default AppHeaderDesktop;